import { isValid } from '@fnando/cpf';
import { createAlphanumericFormatter } from '../generators/index.js';
const PERSON_ID = 'person-id';
const PersonIdFormatter = createAlphanumericFormatter({
    invalidMessage: 'tws.formatter.personid.invalid',
    mask: '000.000.000-00',
    name: PERSON_ID,
    validate: isValid,
});
export { PERSON_ID, PersonIdFormatter, };
export default PersonIdFormatter;
//# sourceMappingURL=person-id.js.map